/**
 * A simple js element for a switch button that toggles between two panels
 */
define('switch-element',['elements'], function(elements) {
	elements.register(function(context) {
		context.find('.switch').each(function() {
			var group = $(this);
			console.log(this);
			var button = group.find('.switch-button');
			var panel1 = group.find('.switch-element').first();
			var panel2 = group.find('.switch-element').last();
			panel2.hide();
			button.click(function() {
				if (panel1.is(':visible')) {
					panel1.hide();
					panel2.show();
				} else {
					panel1.show();
					panel2.hide();
				}
			});
		});
	});
});

